import { put } from 'redux-saga/effects';
import PersonCountActions from '../redux/PersonCountRedux';
import i18n from '../i18n';

export function* getPersonCount(api, { customerId, sites }) {
  try {
    const getPersonCountResponse = yield api.getPersonCount(customerId, sites);
    // console.log('getPersonCountResponse:', getPersonCountResponse);
    if (getPersonCountResponse.ok) {
      yield put(PersonCountActions.getPersonCountRequestSuccess(getPersonCountResponse.data));
    } else {
      api.checkAuth(getPersonCountResponse);
      const error =
        typeof getPersonCountResponse.problem !== 'undefined'
          ? getPersonCountResponse.problem
          : typeof getPersonCountResponse.data.error !== 'undefined'
          ? i18n.t(getPersonCountResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(PersonCountActions.getPersonCountRequestFailure(error));
    }
  } catch (error) {
    console.log('error in PersonCount saga', error);
    yield put(PersonCountActions.getPersonCountRequestFailure(error));
  }
}
